<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    max-width="630"
    max-height="388"
    :style="{ background: $vuetify.theme.themes.surface_tertiary }"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip v-if="type === 1" left color="surface_neutral_selected">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div
            :class="['card-action-box', actionVariant]"
            role="button"
            aria-label="Enviar para pasta"
            v-bind="{ ...attrs, ...tooltipAttrs }"
            v-on="{ ...on, ...tooltipOn }"
            @click="openDialog"
          >
            <v-icon>mdi-folder-plus</v-icon>
          </div>
        </template>
        <span>Enviar para pasta</span>
      </v-tooltip>
      <v-btn v-else small text class="menu-item-btn" @click="openDialog" v-bind="attrs" v-on="on">
        <v-icon size="18" class="mr-2">mdi-folder-plus</v-icon>
        <span>Enviar para pasta</span>
      </v-btn>
    </template>

    <v-card flat style="border-radius: var(--sc-radius-xl); overflow: visible">
      <v-btn icon small class="sc-modal__close" @click="close">
        <v-icon size="18">mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon size="20" class="mr-2" color="text_secondary">mdi-folder-plus</v-icon>
        <div>
          <span class="sc-modal__title">Enviar para pasta</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Pasta</label>
          <v-select
            dense solo flat hide-details
            v-model="cod_pasta"
            :items="pastas"
            placeholder="Escolha uma pasta"
            background-color="surface_tertiary"
            item-value="cod_pasta"
            item-text="dsc_nome_pasta"
            class="sc-modal__field-input"
          />
        </div>
      </div>

      <div class="sc-modal__footer">
        <v-btn text class="modal-btn-cancel" @click="close">Cancelar</v-btn>
        <v-btn
          color="primary"
          class="modal-btn-confirm"
          :loading="loading"
          @click.prevent="
            isNoticia ? enviarNoticiaParaPasta() : isEnquete ? enviarEnqueteParaPasta() : enviarColaboracaoParaPasta()
          "
        >Enviar</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    id_colaboracao: String,
    cod_producao: Number,
    cod_noticia: String,
    id_enquete: Number,
    isNoticia: Boolean,
    isEnquete: Boolean,
    type: {
      type: Number,
      default: 0,
    },
    actionVariant: {
      type: String,
      default: "card-action-box--more",
    },
  },
  data() {
    return {
      loading: false,
      cod_pasta: null,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters({
      pastas: "pastas/getterPastas",
    }),
  },
  methods: {
    ...mapActions({ getPastas: "pastas/getPastas" }),
    async openDialog() {
      this.$emit("open");
      await this.getPastas({ cod_producao: this.cod_producao });
      this.dialog = true;
    },
    async enviarColaboracaoParaPasta() {
      try {
        this.loading = true;

        if (!this.cod_pasta) {
          return this.$toast.error(
            "Escolha para qual pasta deseja enviar a colaboração. "
          );
        }

        const payload = {
          id_colaboracao: this.id_colaboracao,
          cod_pasta: this.cod_pasta,
        };

        const response = await apiClient.post("/pastas/inserirColaboracaoPasta", payload);

        if (response.status === 200) {
          this.$toast.success("Colaboração enviada para pasta com sucesso.");
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
    async enviarEnqueteParaPasta() {
      try {
        this.loading = true;
        if (!this.cod_pasta) {
          return this.$toast.error(
            "Escolha para qual pasta deseja enviar a colaboração. "
          );
        }
        const payload = {
          cod_pasta: this.cod_pasta,
          id_enquete: this.id_enquete
        }

        const response = await apiClient.post("/pastas/inserirEnquetePasta", payload);
        if(response.status === 200) {
          this.$toast.success("Enquete enviada para pasta com sucesso.");
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
    async enviarNoticiaParaPasta() {
      try {
        this.loading = true;

        if (!this.cod_pasta) {
          return this.$toast.error(
            "Escolha para qual pasta deseja enviar a colaboração. "
          );
        }

        const payload = {
          cod_noticia: this.cod_noticia,
          cod_pasta: this.cod_pasta,
        };

        const response = await apiClient.post("/pastas/inserirNoticiaPasta  ", payload);

        if (response.status === 200) {
          this.$toast.success("Noticia enviada para pasta com sucesso.");
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.dialog = false;
      this.loading = false;
      this.cod_pasta = null;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
